import React, { useState } from 'react';

import { t } from 'i18next';
import { Trans } from 'react-i18next';

import BdsIconButton from '../../../../../shared/components/v3/Buttons/BdsIconButton/BdsIconButton';
import { CHEVRON_DOWN_V3, CHEVRON_UP_V3 } from '../../../../../shared/constants/images';
import { TRANSLATION_POINTS_BY_FILE } from '../../../../../shared/translations/rewards';
import './RewardsEmailModelSelector.scss';

interface IRewardsEmailModelSelector {
  onChanged: (value: string) => void;
  value?: string;
}

const RewardsEmailModelSelector = ({ onChanged, value }: IRewardsEmailModelSelector) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleModelSelect = (value: string) => {
    onChanged(value);
    setIsCollapsed(false);
  };

  const modelsOptions = [
    {
      name: TRANSLATION_POINTS_BY_FILE.emailsConfiguration.category.generic,
      value: 'default'
    },
    { name: TRANSLATION_POINTS_BY_FILE.emailsConfiguration.category.celebration, value: 'generic-celebration' },
    { name: TRANSLATION_POINTS_BY_FILE.emailsConfiguration.category.birthday, value: 'birthday' },
    { name: TRANSLATION_POINTS_BY_FILE.emailsConfiguration.category.christmas, value: 'christmas' }
  ];

  const renderSelection = () => {
    const selectedOption = modelsOptions.find((option) => option.value === value);
    return selectedOption ? (
      <Trans i18nKey={selectedOption.name} />
    ) : (
      t(TRANSLATION_POINTS_BY_FILE.emailsConfiguration.selectorPlaceholder)
    );
  };

  return (
    <div className="email-selector-container">
      <p className="selector-title">
        <Trans i18nKey={TRANSLATION_POINTS_BY_FILE.emailsConfiguration.selectorTitle} components={{ b: <b></b> }} />
      </p>
      <button
        className="placeholder-container flex flex-row w-full justify-between items-center"
        onClick={handleToggleCollapse}
      >
        <p className={`placeholder ${value ? 'selected' : ''}`}>{renderSelection()}</p>
        <BdsIconButton
          action={handleToggleCollapse}
          icon={isCollapsed ? CHEVRON_UP_V3 : CHEVRON_DOWN_V3}
          size="sm"
          variant="transparent"
        />
      </button>
      <div className={`models-options-container ${isCollapsed ? 'expanded' : ''}`}>
        {modelsOptions.map((option) => (
          <button key={option.value} className={'model-option'} onClick={() => handleModelSelect(option.value)}>
            {t(option.name)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RewardsEmailModelSelector;
